import TargetingCriteriaType from '@/common/enums/TargetingCriteriaType.enum';
import Validatable from '@/validator/Validatable';

import TargetingCriterionSubType, { ITargetingCriterionSubTypeAPI } from './TargetingCriterionSubType';

interface ITargetingCriterionAPI {
  targetingcriterion_id: number;
  name: string;
  type: string;
  targetingcriterion_subtypes: ITargetingCriterionSubTypeAPI[];
  is_update_pushed_externally: boolean;
}

export default class TargetingCriterion extends Validatable<TargetingCriterion> {
  name: string;
  type: TargetingCriteriaType;
  subTypes: TargetingCriterionSubType[];
  isUpdatePushedExternally: boolean;

  constructor(id = -1, name = '', type?: TargetingCriteriaType, subTypes = null, isUpdatePushedExternally = false) {
    super();
    this.id = id;
    this.name = name;
    this.type = type as TargetingCriteriaType;
    this.subTypes = subTypes;
    this.isUpdatePushedExternally = isUpdatePushedExternally;
  }

  static fromApi(apiObject: ITargetingCriterionAPI) {
    return new TargetingCriterion(
      apiObject.targetingcriterion_id,
      apiObject.name,
      apiObject.type as TargetingCriteriaType,
      apiObject.targetingcriterion_subtypes != null
        ? apiObject.targetingcriterion_subtypes.map((x) => TargetingCriterionSubType.fromApi(x))
        : undefined,
      apiObject.is_update_pushed_externally,
    );
  }

  static fromObject(obj) {
    return super.fromObject(obj, new TargetingCriterion());
  }

  toApi() {
    return <ITargetingCriterionAPI>{
      targetingcriterion_id: this.id >= 0 ? this.id : undefined,
      name: this.name,
      type: this.type,
      targetingcriterion_subtypes: this.subTypes != null ? this.subTypes.map((x) => x.toApi()) : undefined,
      is_update_pushed_externally: this.isUpdatePushedExternally,
    };
  }

  static validatorCreateRules() {
    return {};
  }
}
